import axios from "axios";

const GUEST_USER_ID = "000000000000000000000000";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "x-client-type": "web",
    "secret-key": "5TIvw5cpc0",
  },
});

/* ================= REQUEST INTERCEPTOR ================= */

api.interceptors.request.use(
  (config) => {
    let userId = GUEST_USER_ID;

    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        if (parsed && parsed._id) {
          userId = parsed._id;
        }
      } catch {}
    }

    /* ? Attach userId */
    config.params = {
      ...(config.params || {}),
      userId,
    };

    /* ? Attach JWT token if exists */
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE INTERCEPTOR ================= */

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // ? DO NOT force redirect for guest APIs
    if (error.response?.status === 401) {
      console.warn("Unauthorized request");
    }
    return Promise.reject(error);
  }
);

export default api;
